import React from 'react'
import CookieConsent from 'react-cookie-consent'
import * as routes from '../routes'

const excludedBasePaths = [
  routes.producerReportBasePath,
]

const CookieConsentBar = ({cookieName, onAccept}) => !excludedBasePaths.some(x => window.location.pathname.startsWith(x)) &&
  <CookieConsent
    enableDeclineButton
    disableStyles
    containerClasses='cookie-consent'
    contentClasses='cookie-consent__content'
    buttonClasses='cookie-consent__button'
    declineButtonClasses='cookie-consent__button'
    buttonText='Allow Optional'
    declineButtonText='Necessary Only'
    cookieName={cookieName}
    cookieValue='accepted'
    declineCookieValue='declined'
    onAccept={onAccept}
  >
    This website uses <a href='https://voloco.com/cookie-policy/'>cookies</a> for your best experience.
  </CookieConsent>

export default CookieConsentBar
